<div class="requiredSignature__badge__container">
  <mat-icon 
    matBadge="{{(requiredSignatureTotal$| async).toString()}}"
    matBadgeSize="small"
    matBadgeHidden="{{(requiredSignatureTotal$| async) === 0}}"
    data-testid="signature-text"
    class="requiredSignature__badge__icon"
    matBadgePosition="above right"
    matTooltip="Signatures"
    matTooltipClass="scorecard-icon-tooltip"
  >
  </mat-icon>
  <span class="cdk-visually-hidden">Count of required Signatures remaining to sign</span>
</div>